import { useTranslation } from "react-i18next";
import { Link } from "react-router-dom";

const Cancel = () => {
  const { t } = useTranslation(["billing", "common"]);

  return (
    <div
      data-testid="page-checkout-cancel"
      className="card p-8 max-w-md mx-auto mt-12 text-center"
    >
      <h1 className="mb-2 font-display text-2xl font-black">
        {t("checkout.cancelTitle")}
      </h1>
      <p className="mb-6 text-ink-soft">{t("checkout.cancelBody")}</p>
      <Link to="/pricing" className="btn-ghost">
        {t("common:actions.back")}
      </Link>
    </div>
  );
};

export default Cancel;
